import Component from '../abstracts/Component';
import 'bootstrap'; //TODO: import single component


export default class TabsComponent extends Component {

  get SELECTORS() {
    return {
      main: '[data-tabs]',
      tabs: '[data-toggle="tab"]'
    };
  }

  get CLASSES() {
    return {
      show: 'show'
    };
  }

  constructor() {
    super();

    this.mainTarget = $(this.SELECTORS.main);

  }

  initTabs() {
    let ctx = this;

    this.$one('click', ({event}) => {
      event.preventDefault();

        $('[data-tabs]').tab();
        $(event.target).tab('show');
          this.log('Tab initialized');

    }, this.SELECTORS.tabs)
  }


  bindEvents() {
    this.initTabs();
  }

  render() {
    this.bindEvents();
  }
}

